import React from 'react';
import {ButtonGroup, Card, CardBody} from "reactstrap";

import NTMTable from "../../components/Table/NTMTable";
import NTMButton from "../../components/Buttons/NTMButton";
import {SuccessDialog, ConfirmDialog, ErrorDialog} from "@nextome/messages";
import EditUserModal from "./EditUserModal";
import moment from "moment";
import {Link} from "react-router-dom";
import {getUserTypeName, USER_TYPE} from "../../redux/users/userTypes";

export default class UsersPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			modal: false,
			donors: 0,
			partners: 0,
			supervisors: 0,
			fundSuperv: 0,
			beneficiary: 0
		};
	}

	countUsers = (users) => {
		let donors = 0;
		let partners = 0;
		let supervisors = 0;
		let beneficiary = 0;
		let fundSuperv = 0;
		users.forEach(u => {
			switch (u.type) {
				case USER_TYPE.USER:
					donors++;
					break;
				case USER_TYPE.PARTNER:
					partners++;
					break;
				case USER_TYPE.CARITAS_SUPERVISOR:
					supervisors++;
					break;
				case USER_TYPE.BENEFICIARY:
					beneficiary++;
					break;
				case USER_TYPE.DIOCESE_ADMIN:
					supervisors++;
					break;
				case USER_TYPE.FUND_SUPERVISOR:
					fundSuperv++;
					break;
				case USER_TYPE.FUND_ADMIN:
					fundSuperv++;
					break;
			}
		});
		this.setState({donors, partners, supervisors, beneficiary, fundSuperv});
	};

	componentDidMount() {
		this.countUsers(this.props.users);
	}

	componentWillReceiveProps(nextProps) {
		this.countUsers(nextProps.users);
	}

	closeModal = () => {
		this.setState({
			modal: null
		});
	};

	openModal = (modal) => {
		this.setState({
			modal
		});
	};

	editUser = (user) => {
		this.openModal(
			<EditUserModal
				user={user}
				onSubmit={(values) => {

					if ((user.type === USER_TYPE.DIOCESE_ADMIN && user.type !== values.type) ||
						(user.type === USER_TYPE.CARITAS_SUPERVISOR && values.type === USER_TYPE.DIOCESE_ADMIN)) {
						this.openModal(
							<ErrorDialog
								onClose={this.closeModal}
								message={"Per modificare l'amministratore della diocesi vai dall'apposita pagina 'Diocesi'"}
							/>);
					} else {
						this.props.updateUser(values);
						this.closeModal();
					}
				}}
				onClose={this.closeModal}
			/>);
	};

	getSuccessMessage = (title) => {
		this.openModal(<SuccessDialog onConfirm={this.closeModal} title={title}/>);
	};

	getConfirmMessage = (title, message, buttonText, confirmMessage, onConfirm) => {
		this.openModal(
			<ConfirmDialog
				title={title}
				message={message}
				confirmBtnText={buttonText}
				onCancel={this.closeModal}
				onConfirm={() => {
					onConfirm();
					this.getSuccessMessage(confirmMessage);
				}}
			/>
		);
	};

	render() {
		let data = this.state.selected ? this.props.users.filter(u => this.state.selected === USER_TYPE.CARITAS_SUPERVISOR ? u.type === this.state.selected || u.type === USER_TYPE.DIOCESE_ADMIN : u.type === this.state.selected) : this.props.users;

		let {selected} = this.state;
		let {cards, users} = this.props;

		if (!selected) data = this.props.users;
		else if (selected === USER_TYPE.CARITAS_SUPERVISOR) data = users.filter(u => u.type === selected || u.type === USER_TYPE.DIOCESE_ADMIN);
		else if (selected === USER_TYPE.FUND_SUPERVISOR) data = users.filter(u => u.type === selected || u.type === USER_TYPE.FUND_ADMIN);

		if (this.state.selected === USER_TYPE.BENEFICIARY) {
			data.forEach(user => {
				let card = cards.find(c => c.beneficiaryId === user.uid);
				if (card) user.issuer = {name: card.dioceseName, id: card.dioceseId};
			});
		}

		return (
			<Card>
				{this.state.modal}
				<CardBody>
					<div>
						<ButtonGroup>
							<NTMButton
								primary
								onClick={() => this.setState({selected: null})}
								outline={this.state.selected}>
								Tutti ({this.props.users.length})
							</NTMButton>
							<NTMButton
								primary
								onClick={() => this.setState({selected: USER_TYPE.USER})}
								outline={this.state.selected !== USER_TYPE.USER}>
								Donatori ({this.state.donors})
							</NTMButton>
							<NTMButton
								primary
								onClick={() => this.setState({selected: USER_TYPE.PARTNER})}
								outline={this.state.selected !== USER_TYPE.PARTNER}
							>Partner ({this.state.partners})</NTMButton>
							<NTMButton
								primary
								onClick={() => this.setState({selected: USER_TYPE.CARITAS_SUPERVISOR})}
								outline={this.state.selected !== USER_TYPE.CARITAS_SUPERVISOR}
							>Supervisori Caritas
								({this.state.supervisors})</NTMButton>
							<NTMButton
								primary
								onClick={() => this.setState({selected: USER_TYPE.FUND_SUPERVISOR})}
								outline={this.state.selected !== USER_TYPE.FUND_SUPERVISOR}
							>Supervisori Fondi
								({this.state.fundSuperv})</NTMButton>
							<NTMButton
								primary
								onClick={() => this.setState({selected: USER_TYPE.BENEFICIARY})}
								outline={this.state.selected !== USER_TYPE.BENEFICIARY}
							>Beneficiari
								({this.state.beneficiary})</NTMButton>
						</ButtonGroup>
					</div>

					<NTMTable className={"table-admin"}
					          header={
						          this.state.selected === USER_TYPE.BENEFICIARY ?
							          [
								          {
									          Header: 'Nome',
									          accessor: 'firstName' // String-based value accessors!
								          },
								          {
									          Header: 'Cognome',
									          accessor: 'lastName',
								          },
								          {
									          Header: 'Città',
									          accessor: 'city'
								          },
								          {
									          Header: 'Data di nascita',
									          accessor: 'birthday'
								          },
								          {
									          Header: 'Data di iscrizione',
									          accessor: 'createdAt',
									          Cell: props => <div>
										          {moment(props.original.createdAt).format("DD/MM/YYYY")}
									          </div>,
									          filterable: false
								          },
								          {
									          Header: "Diocesi/fondo",
									          accessor: "issuer.name",
									          Cell: props => <div>
										          {props.original.issuer ?
											          <Link
												          to={"/dioceses/" + props.original.issuer.id}>{props.original.issuer.name}</Link> :
											          "-"
										          }
									          </div>,
								          },
								          {
									          accessor: 'details',
									          filterable: false,
									          Cell: props => <div>
										          <NTMButton primary outline
										                     onClick={() => this.editUser(Object.assign({}, props.original))}
										          >
											          <i className={"fa fa-pencil-square"}/>
										          </NTMButton>
									          </div>
								          }] :
							          [
								          {
									          Header: 'Nome',
									          accessor: 'firstName' // String-based value accessors!
								          },
								          {
									          Header: 'Cognome',
									          accessor: 'lastName',
								          },
								          {
									          Header: 'Email',
									          accessor: 'email'
								          },
								          {
									          Header: 'Città',
									          accessor: 'city'
								          },
								          {
									          Header: 'Data di nascita',
									          accessor: 'birthday'
								          },
								          {
									          Header: 'Data di iscrizione',
									          accessor: 'createdAt',
									          Cell: props => <div>
										          {moment(props.original.createdAt).format("DD/MM/YYYY")}
									          </div>,
									          filterable: false
								          },
								          {
									          Header: 'Ultimo accesso',
									          accessor: 'lastAccess',
									          Cell: props => <div>
										          {props.original.lastAccess && props.original.lastAccess !== -1 ?
											          moment(props.original.lastAccess).format("DD/MM/YYYY")
											          :
											          "-"
										          }
									          </div>,
									          sortMethod: (a = 0, b = 0) => {
										          return b - a;
									          },
									          filterable: false
								          },
								          {
									          Header: "Tipologia",
									          accessor: 'type',
									          Cell: props => <div>
									          {getUserTypeName(props.original.type, "usersPage")}
									          </div>,
									          filterable: false
								          },
								          {
									          Header: "Abilitato",
									          accessor: 'enabled',
									          filterable: false,
									          Cell: props => <div>

										          {props.original.type === USER_TYPE.BENEFICIARY ?
											          <div/>
											          :

											          <i className={"fa fa-circle"}
											             style={{
												             cursor: "pointer",
												             color: props.original.enabled ? "green" : "red"
											             }}
											             onClick={() =>
												             this.getConfirmMessage(
													             !props.original.enabled ? "Abilitare utente?" : "Disabilitare utente?",
													             props.original.enabled ?
														             "Se disabiliti l'utente non potrà più accedere all'applicazione" :
														             "Se riattivi l'utente avrà accesso completo all'app",
													             props.original.enabled ? "Disabilita" : "Abilita",
													             props.original.enabled ? "Utente Disabilitato" : "Utente abilitato",
													             () => this.props.setUserEnabled(props.original.uid, !props.original.enabled))
											             }
											          />
										          }
									          </div>
								          },
								          {
									          accessor: 'details',
									          filterable: false,
									          Cell: props => <div>
										          <NTMButton primary outline
										                     onClick={() => this.editUser(Object.assign({}, props.original))}
										          >
											          <i className={"fa fa-pencil-square"}/>
										          </NTMButton>
									          </div>
								          }]
					          }
					          body={data}
					          filterable
					          defaultPageSize={10}
					>
					</NTMTable>
				</CardBody>
			</Card>
		);
	}
}
